export default __webpack_public_path__ + "static/media/g3-solar-bg-2.63bb1650.jpeg";